import { Box, Stack, Title, Flex, Image, Button } from '@mantine/core';
import { useEffect, useState } from 'react';
import loading from 'assets/report/loading.gif';
import { GradientButton } from 'components/GradientButton';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { API } from 'services';

export function TimesheetPage() {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // prevent horizontal scroll back and forward navigation
    // because our datatable require horizontal scroll alots
    const cached = document.body.style.overscrollBehaviorX;
    document.body.style.overscrollBehaviorX = 'none';
    return () => {
      document.body.style.overscrollBehaviorX = cached;
    };
  }, []);

  const report = useQuery([], () => {
    setLoading(true); // Set loading state to true before making the API request
    return API.getTimesheetListing({})
      .then((res) => {
        setLoading(false); // Set loading state to false when the request is complete
        return res.data;
      })
      .catch((error) => {
        setLoading(false); // Make sure to set loading state to false in case of an error
        throw error;
      });
  });

  return (
    <Stack px={{ base: 0, md: 30 }}>
      {isLoading && (
        <Box className={'loading_box'}>
          <Image src={loading} width="100"></Image>
        </Box>
      )}
      <Flex className={'flex_wrap'}>
        <Box className={'w100 md_w100'}>
          <Box bg="#FFF" p={20}>
            <Box mb={20} className="flex flex_direction_row flex_align_center flex_justify_between">
              <Title order={2}>Timesheets</Title>
              <GradientButton px={40} onClick={() => navigate('/timesheets/create')}>
                Create Timesheet
              </GradientButton>
            </Box>
            <Box my={30} style={{ overflowX: 'auto' }}>
              <table className="reportTable">
                <thead>
                  <tr>
                    <th style={{ background: '#f2f4fd' }}>Date</th>
                    <th style={{ background: '#f2f4fd' }}>No.</th>
                    <th style={{ background: '#f2f4fd' }}>Course Name</th>
                    <th style={{ background: '#f2f4fd' }}>Sign In</th>
                    <th style={{ background: '#f2f4fd' }}>Sign Out</th>
                    <th style={{ background: '#f5fdfc' }}>No. of Assessment</th>
                    <th style={{ background: '#fefaf3' }}>No of Hours Worked</th>
                    <th style={{ background: '#fefaf3' }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {report.data &&
                    report.data.TrainerTimesheet &&
                    report.data.TrainerTimesheet.length > 0 &&
                    report.data.TrainerTimesheet.map((item: any, index: number) => (
                      <tr key={index}>
                        <td>{item['trainertimesheet_date']}</td>
                        <td>
                          <a
                            href={'/timesheets/details?timesheet_id=' + item.id}
                            style={{
                              cursor: 'pointer',
                              color: '#228be6',
                              textDecoration: 'underline',
                            }}
                          >
                            {item['trainertimesheet_no']}
                          </a>
                        </td>
                        <td>
                          {item['course_title']} - ({item['courserun_apicourserunid']})<br />
                          <br />
                          {item['courserun_course_from']} - {item['courserun_course_to']}
                        </td>
                        <td> {item['trainertimesheet_sign_in_coa']}</td>
                        <td> {item['trainertimesheet_sign_out_coa'] ?? '-'}</td>
                        <td> {item['trainertimesheet_assessment_count']}</td>
                        <td> {item['trainertimesheet_working_hrs']}</td>
                        <td>
                          {item['trainertimesheet_status'] == 'Submitted' && (
                            <Flex direction={'column'}>
                              <span
                                className="mb-2"
                                style={{ color: '#ffbd43', fontWeight: '600' }}
                              >
                                {'Submitted'}
                              </span>
                              {item['trainertimesheet_sign_out_coa'] == null && (
                                <Button
                                  m={4}
                                  style={{ backgroundColor: '#00ab84' }}
                                  onClick={() =>
                                    navigate('/timesheets/signout?timesheet_id=' + item.id)
                                  }
                                  className={''}
                                >
                                  Sign Out
                                </Button>
                              )}
                            </Flex>
                          )}
                          {item['trainertimesheet_status'] == 'Rejected' && (
                            <>
                              <span style={{ color: '#fa5252', fontWeight: '600' }}>
                                {'Rejected'}
                              </span>
                              <br></br>
                              <span>Remarks: {item['trainertimesheet_status_remark'] ?? '-'}</span>
                              <br></br>
                              <Button
                                m={4}
                                style={{ backgroundColor: '#00ab84' }}
                                onClick={() => navigate('/timesheets/edit?timesheet_id=' + item.id)}
                                className={''}
                              >
                                Edit
                              </Button>
                            </>
                          )}

                          {(item['trainertimesheet_status'] == 'Approved' ||
                            item['trainertimesheet_status'] == 'Completed') && (
                            <span style={{ color: '#00ab84', fontWeight: '600' }}>
                              {item['trainertimesheet_status']}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  {report.data &&
                    report.data.TrainerTimesheet &&
                    report.data.TrainerTimesheet.length <= 0 && (
                      <tr>
                        <td colSpan={5}>{'No Timesheet Available'}</td>
                      </tr>
                    )}
                </tbody>
              </table>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Stack>
  );
}
